module.exports = __webpack_public_path__ + "img/BlocodeLogo.7a27a5f4.png";